import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { OrganizationDataGateway } from './organization-data.gateway'
import { CurrentUser } from '../../common/models/current-user'
import { OrgBrowserView } from '../models/org-browser-view'

@Injectable()
export class NetworkOrganizationDataGateway extends OrganizationDataGateway {
    constructor(private http: HttpClient) {
        super()
    }

    getPWOrganization(pwEntityId: number, orgId: number): Observable<OrgBrowserView> {
        return this.http.get<OrgBrowserView>('../api/GetPWOrgForBrowser/' + orgId + '/' + pwEntityId)
    }

    getOrganization(orgId: number): Observable<OrgBrowserView> {
        return this.http.get<OrgBrowserView>('../api/GetOrgForBrowser/' + orgId)
    }

    getOrganizationsForParent(parentOrgId: number): Observable<OrgBrowserView[]> {
        return this.http.get<OrgBrowserView[]>('../api/GetChildOrgsForBrowser/' + parentOrgId)
    }

    getPWOrganizationsForParent(parentPWEntityId: number, basePWEntityId): Observable<OrgBrowserView[]> {
        return this.http.get<OrgBrowserView[]>('../api/getPWChildOrgsForBrowser/' + parentPWEntityId + '/' + basePWEntityId)
    }

    getPWOrganizationsForParentAll(parentPWEntityId: number, basePWEntityId): Observable<OrgBrowserView[]> {
        return this.http.get<OrgBrowserView[]>('../api/getPWAllChildOrgsForBrowser/' + parentPWEntityId + '/' + basePWEntityId)
    }

    searchOrganization(keyWord: string): Observable<OrgBrowserView[]> {
        return this.http.get<OrgBrowserView[]>('../api/SearchOrganizations/' + encodeURIComponent(keyWord))
    }
}
